// extracted by mini-css-extract-plugin
module.exports = {"headerCell":"styles_headerCell__2pGvE","slideInFromRight":"styles_slideInFromRight__1uSKo"};